import { FilterIcon } from '@sketchnote/icons';
import classNames from 'classnames';

export interface FilterLabelProps {
  label: string;
  isFilterOpened: boolean;
}

export const FilterLabel = ({ label, isFilterOpened }: FilterLabelProps) => (
  <div
    className={classNames({
      'flex items-center font-medium text-sm': true,
      'text-gray-999': isFilterOpened,
    })}
  >
    <FilterIcon className="mr-5" />
    <span>{`${label}`}</span>
  </div>
);
